import { render, staticRenderFns } from "./SplitTruckTableView.vue?vue&type=template&id=c139f744"
import script from "./SplitTruckTableView.vue?vue&type=script&lang=ts"
export * from "./SplitTruckTableView.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports